import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useImplantContext } from '../../store/implant-context';
import EditImplant from '../edit-implant/EditImplant';
import styles from './AppImplantPage.module.css';

const AddImplantPage = () => {
    const { setFileName, setUsesExistingFile } = useImplantContext();

    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const currentFileName = queryParams.get('fileName');
    const refresh = queryParams.get('refresh');

    useEffect(() => {
        if (refresh) {
            window.location.href = '/add-implant';
        }
    }, [refresh]);

    useEffect(() => {
        if (currentFileName) {
            setFileName(currentFileName);
            setUsesExistingFile(true);
        }
    }, [currentFileName, setFileName, setUsesExistingFile]);

    useEffect(() => {
        if (showSuccessMessage) {
            const timer = setTimeout(() => {
                setShowSuccessMessage(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [showSuccessMessage]);

    const handleSubmit = () => {
        setShowSuccessMessage(true);
        setFileName('');
    };

    return (
        <div className={styles.wrapper}>
            <h1>Add New Implant</h1>
            {showSuccessMessage ? (
                <div>Implant was successfully saved!</div>
            ) : (
                <>
                    <EditImplant isNew={true} onSubmit={handleSubmit} />
                </>
            )}
        </div>
    );
};

export default AddImplantPage;
